import React from 'react';
import { Flex, Box, Text, Image, Show, Hide } from "@chakra-ui/react";

const highlightText = (prompt: string, highlightedWords: any[]) => {
  let highlightedText = prompt;

  const sortedHighlightedWords = highlightedWords.sort((a, b) => b.Word.length - a.Word.length);

  sortedHighlightedWords.forEach((highlight) => {
    const regex = new RegExp(`(${highlight.Word})`, 'gi');
    highlightedText = highlightedText.replace(
      regex,
      `<span style="color: ${highlight.Color}; font-weight: bold;">$1</span>`
    );
  });

  return <span dangerouslySetInnerHTML={{ __html: highlightedText }} />;
};


const ImageSection = ({
  title,
  prompt,
  mainImage,
  highlightedWords,
}: {
  title: string;
  prompt: string;
  mainImage: any;
  highlightedWords: any[];
}) => {
  const imageUrl = mainImage?.data?.attributes?.url || "/default-image.png";
  const imageAlt = mainImage?.data?.attributes?.alternativeText || "Main Image"; 

  return (
    <Flex
      mt="40px"
      direction="column"
      align="center"
      justify="center"
      width="100%"
      px={{ base: "20px", sm: "35px", md: "40px", lg: "60px", xl: "60px", "2xl": "12%" }}
    >
      {/* Mobile View */}
      <Show below="lg">
        <Box textAlign="left" maxW="90%" mb="20px" ml="0px" mr="auto" px="0">
          <Text fontSize={{ base: "24px", md: "32px", lg: "48px" }} fontWeight="600" lineHeight={{ base: "30px", md: "62.4px" }} color="white">
            {title}
          </Text>
        </Box>

        <Flex align="center" mt="10px" justify="center">
          <Image
            src="AvatarImagehome.png"
            alt="Avatar"
            width="78px"
            height="78px"
            flexShrink="0"
            borderRadius="9px"
            background="var(--avatar-male-eric-yates-emoji, url(AvatarImage.png) lightgray 50% / cover no-repeat)"
          />
          <Box ml="10px">
            <Text fontSize="16px" fontWeight="600" lineHeight="22.4px" color="#FFF">
              {highlightText(prompt, highlightedWords)}
            </Text>
          </Box>
        </Flex>

        <Flex mt="10px" gap="10px" flexWrap="wrap" justify="center">
          {highlightedWords?.map((word: any, index: number) => (
            <Box
              key={index}
              display="flex"
              height="27px"
              padding="8px 16px"
              justifyContent="center"
              alignItems="center"
              gap="8px"
              borderRadius="32px"
              border="2px solid #374151"
            >
              <Text color={word.Color} fontWeight="semibold">
                {word.Word}
              </Text>
            </Box>
          ))}
        </Flex>

        <Box
          position="relative"
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="90%"
          mt="20px"
        >
          <Image
            src={imageUrl} 
            alt={imageAlt} 
            width="100%"
            height="100%"
            position="relative"
            zIndex="1"
            mx="10px"
          />
        </Box>
      </Show>

      {/* Desktop View */}
      <Hide below="lg">
        <Flex
          direction={{ base: "column", lg: "row" }}
          align="center"
          justify="center"
          width="100%"
          p="20px"
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width={{ base: "100%", lg: "50%" }}
            mb={{ base: "20px", lg: "0" }}
          >
            <Image
              src={imageUrl} 
              alt={imageAlt} 
              width="70%"
              height="100%"
              mx="10px"
            />
          </Box>

          <Box
            textAlign={{ base: "left", lg: "left" }}
            maxW={{ base: "90%", lg: "50%" }}
            mt={{ base: "20px", lg: "0" }}
            zIndex="2"
          >
            <Text fontSize={{ base: "24px", md: "32px", lg: "48px" }} fontWeight="600" lineHeight={{ base: "30px", md: "62.4px" }} color="white">
              {title}
            </Text>
            <Flex align="center" mt="10px" justify={{ base: "center", lg: "flex-start" }}>
              <Image
                src="AvatarImagehome.png"
                alt="Avatar"
                width="78px"
                height="78px"
                flexShrink="0"
                borderRadius="9px"
                background="var(--avatar-male-eric-yates-emoji, url(AvatarImage.png) lightgray 50% / cover no-repeat)"
              />
              <Box ml="10px">
                <Text fontSize="16px" fontWeight="600" lineHeight="22.4px" color="#FFF">
                  {highlightText(prompt, highlightedWords)}
                </Text>
              </Box>
            </Flex>
            <Flex mt="10px" gap="10px" flexWrap="wrap" justify={{ base: "center", lg: "flex-start" }}>
              {highlightedWords?.map((word: any, index: number) => (
                <Box
                  key={index}
                  display="flex"
                  height="27px"
                  padding="8px 16px"
                  justifyContent="center"
                  alignItems="center"
                  gap="8px"
                  borderRadius="32px"
                  border="2px solid #374151"
                >
                  <Text color={word.Color} fontWeight="semibold">
                    {word.Word}
                  </Text>
                </Box>
              ))}
            </Flex>
          </Box>
        </Flex>
      </Hide>
    </Flex>
  );
};

export default ImageSection;
